module.exports = __webpack_public_path__ + "img/Documentation_Collapsed_Small_Button.601f4348.svg";